export const SU_MENU = [
    {
        path: 'createPurchaseOrder',
        data: {
            menu: {
                title: 'Purchase Orders',
                icon: 'fa fa-money',
                selected: false,
                expanded: false,
                order: 0,
            },
        },
    },
    {
        path: 'viewVendors',
        data: {
            menu: {
                title: ' Vendors',
                icon: 'fa fa-user-circle ',
                selected: false,
                expanded: false,
                order: 0,
            },
        },
    },


    {
        path: 'viewItems',
        data: {
            menu: {
                title: ' Items',
                icon: 'fa fa-list',
                selected: false,
                expanded: false,
                order: 0,
            },
        },
    },
    {
        path: 'viewCategoryItems',
        data: {
            menu: {
                title: ' Category-Items',
                icon: 'fa fa-puzzle-piece',
                selected: false,
                expanded: false,
                order: 0,
            },
        },
    },
    {
        path: 'viewCategoryVendors',
        data: {
            menu: {
                title: ' Category-Vendors',
                icon: 'fa fa-handshake-o',
                selected: false,
                expanded: false,
                order: 0,
            },
        },
    },
    {
        path: 'viewReports',
        data: {
            menu: {
                title: ' Reports',
                icon: 'fa fa-bar-chart',
                selected: false,
                expanded: false,
                order: 0,
            },
        },
    },
    {
        path: 'viewExpenses',
        data: {
            menu: {
                title: 'Expenses',
                icon: 'icon ion-calculator',
                selected: false,
                expanded: false,
                order: 0,
            },
        },
    },
    {
        path: 'viewUsers',
        data: {
            menu: {
                title: ' Users',
                icon: 'icon ion-person-stalker',
                selected: false,
                expanded: false,
                order: 0,
            },
        },
    },
    {
    path: '',
        data: {
            menu: {
                title: 'Configuration',
                icon: 'fa fa-cog ',
                selected: false,
                expanded: false,
                order: 0,
            },
        },
        children: [
            {
                path: 'almirah',
                data: {
                    menu: {
                        title: ' Almirah',
                        icon: 'fa fa-columns',
                        selected: false,
                        expanded: false,
                        order: 0,
                    },
                },
            },
            {
                path: 'viewCategories',
                data: {
                    menu: {
                        title: ' Categories ',
                        icon: 'fa fa-tags',
                        selected: false,
                        expanded: false,
                        order: 0,
                    },
                },
            },
            {
                path: 'viewTermsAndConditions',
                data: {
                    menu: {
                        title: ' T&C',
                        icon: 'fa fa-file-text-o',
                        selected: false,
                        expanded: false,
                        order: 0,
                    },
                },
            },

            {
                path: 'viewTemplates',
                data: {
                    menu: {
                        title: 'Templates',
                        icon: 'fa fa-file-o',
                        selected: false,
                        expanded: false,
                        order: 0,
                    },
                },
            },
            {
                path: 'viewUnits',
                data: {
                    menu: {
                        title: 'Units',
                        icon: 'fa fa-building',
                        selected: false,
                        expanded: false,
                        order: 0,
                    },
                },
            },
        ],

    },
];

export const ADMIN_MENU = [
    {
        path: 'createPurchaseOrder',
        data: {
            menu: {
                title: 'Purchase Orders',
                icon: 'fa fa-money',
                selected: false,
                expanded: false,
                order: 0,
            },
        },
    },
    {
        path: 'viewVendors',
        data: {
            menu: {
                title: ' Vendors',
                icon: 'fa fa-user-circle ',
                selected: false,
                expanded: false,
                order: 0,
            },
        },
    },
    {
        path: 'viewItems',
        data: {
            menu: {
                title: ' Items',
                icon: 'fa fa-list',
                selected: false,
                expanded: false,
                order: 0,
            },
        },
    },
    {
        path: 'viewCategoryItems',
        data: {
            menu: {
                title: ' Category-Items',
                icon: 'fa fa-puzzle-piece',
                selected: false,
                expanded: false,
                order: 0,
            },
        },
    },
    {
        path: 'viewCategoryVendors',
        data: {
            menu: {
                title: ' Category-Vendors',
                icon: 'fa fa-handshake-o',
                selected: false,
                expanded: false,
                order: 0,
            },
        },
    },
    {
        path: 'viewExpenses',
        data: {
            menu: {
                title: 'Expenses',
                icon: 'icon ion-calculator',
                selected: false,
                expanded: false,
                order: 0,
            },
        },
    },
];




// WEBPACK FOOTER //
// ./src/app/pages/pages.menu.ts